import './styles.scoped.css'
import {Typography, TextField, FormControl, Select, MenuItem, FormHelperText} from '@mui/material'
import {Controller} from 'react-hook-form'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'

export default ({form}) => {
    const employmentTypes = [
        {key: 'full_time', value: 'Full-Time'},
        {key: 'part_time', value: 'Part-Time'},
    ]

    const referralSources = [
        {key: 'employee', value: 'Employee'},
        {key: 'other', value: 'Other'},
    ]

    return (
        <>
            <Typography variant="overline" color="text.secondary">
                EMPLOYMENT INFO
            </Typography>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Employment Type{' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </Typography>
            <FormControl fullWidth error={!!form.formState.errors['employmentType']}>
                <Controller
                    {...form.register('employmentType')}
                    control={form.control}
                    render={({field}) => (
                        <Select
                            {...field}
                            value={field.value ?? ''}
                            onChange={e => field.onChange(e.target.value)}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            displayEmpty
                            renderValue={selected => {
                                if (selected === '') {
                                    return <span style={{color: '#aaa'}}>Select your employment type</span>
                                }
                                return employmentTypes.find(item => item.key === selected)?.value ?? selected
                            }}>
                            {employmentTypes.map(item => (
                                <MenuItem key={item?.key} value={item?.key}>
                                    {item?.value}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
                <FormHelperText>{form.formState.errors['employmentType']?.message}</FormHelperText>
            </FormControl>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Application Date{' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </Typography>
            <Controller
                {...form.register('applicationDate')}
                control={form.control}
                render={({field}) => (
                    <DatePicker
                        {...field}
                        value={field.value ?? null}
                        onChange={newValue => field.onChange(newValue)}
                        enableAccessibleFieldDOMStructure={false}
                        slots={{
                            textField: params => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    error={!!form.formState.errors['applicationDate']}
                                    helperText={form.formState.errors['applicationDate']?.message}
                                />
                            ),
                        }}
                    />
                )}
            />
            <br />
            <br />
            <div className="form">
                <div className="form-left">
                    <Typography variant="inputLabel" color="text.secondary">
                        Referral Source
                    </Typography>
                    <FormControl fullWidth>
                        <Controller
                            {...form.register('referralSource')}
                            control={form.control}
                            render={({field}) => (
                                <Select
                                    {...field}
                                    value={field.value ?? ''}
                                    onChange={e => field.onChange(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                    }}
                                    displayEmpty
                                    renderValue={selected => {
                                        if (selected === '') {
                                            return <span style={{color: '#aaa'}}>Select your referral source</span>
                                        }
                                        return referralSources.find(item => item.key === selected)?.value ?? selected
                                    }}>
                                    {referralSources.map(item => (
                                        <MenuItem key={item?.key} value={item?.key}>
                                            {item?.value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                </div>
                <div className="form-right">
                    <Typography variant="inputLabel" color="text.secondary">
                        Referral Person
                    </Typography>
                    <TextField placeholder="Enter your referral person" fullWidth {...form.register('referralPerson')} />
                </div>
            </div>
            <br />
        </>
    )
}
